export default {
	'lowest_position': {
    cs: 'Lowest position',
    en: 'Lowest position',
    track: 'lowest_position',
		opposite: 'highest_position'
  },
	'low600': {
    cs: 'Lowest position',
    en: 'Lowest position',
    track: 'low600',
  },
	'low750': {
    cs: 'Lowest position',
    en: 'Lowest position',
    track: 'low750',
  },
	'low900': {
    cs: 'Lowest position',
    en: 'Lowest position',
    track: 'low900',
  },
	'low1150': {
    cs: 'Lowest position',
    en: 'Lowest position',
    track: 'low1150',
  },
	'highest_position': {
    cs: 'Highest position',
    en: 'Highest position',
    track: 'highest_position',
		opposite: 'lowest_position'
  },
	'high600': {
    cs: 'Highest position',
    en: 'Highest position',
    track: 'high600',
  },
	'high750': {
    cs: 'Highest position',
    en: 'Highest position',
    track: 'high750',
  },
	'high900': {
    cs: 'Highest position',
    en: 'Highest position',
    track: 'high900',
  },
	'high1150': {
    cs: 'Highest position',
    en: 'Highest position',
    track: 'high1150',
  },
	'position_in_laying': {
    cs: 'Position in laying',
    en: 'Position in laying',
    track: 'position_in_laying',
		opposite: 'position_in_laying_rev',
		required: 'position_in_laying_rev',
		reset: true
  },
	'lowest_position_in_laying': {
    cs: 'Position in laying',
    en: 'Position in laying',
    track: 'lowest_position_in_laying',
  },
	'position_in_laying_rev': {
    cs: 'Position in laying',
    en: 'Position in laying',
    track: 'position_in_laying_rev',
		opposite: 'position_in_laying'
  },
	'feet_up': {
    cs: 'Feet up',
    en: 'Feet up',
    track: 'legs_vert19',
		opposite: 'feet_down'
  },
	'feet_down': {
    cs: 'Feet down',
    en: 'Feet down',
    track: 'legs_vert_min18',
		opposite: 'feet_up'
  },
	'entering_position': {
    cs: 'Entering position',
    en: 'Entering position',
    track: 'entering_position',
    preset: true,
    transitions: {
      'examination_position': 'ent_exa',
      'trendelenburg': 'ent_tre',
      'ultrasonic': 'ent_ult'
    }
  },
	'examination_position': {
    cs: 'Examination position',
    en: 'Examination position',
    track: 'examination_position',
    preset: true,
    transitions: {
      'entering_position': 'exa_ent',
      'trendelenburg': 'exa_tre',
      'ultrasonic': 'exa_ult'
    }
  },
	'ultrasonic': {
    cs: 'Ultrasound position',
    en: 'Ultrasound position',
    track: 'ultrasonic',
    preset: true,
    transitions: {
      'examination_position': 'ult_exa',
      'trendelenburg': 'ult_tre',
      'entering_position': 'ult_ent'
    }
  },
	'legs0degrees': {
		cs: 'Horizontal foot adjustment',
    en: 'Horizontal foot adjustment',
    track: 'legs0degrees',
	},
	'legs0degrees_rev': {
		cs: 'Horizontal foot adjustment',
    en: 'Horizontal foot adjustment',
    track: 'legs0degrees_rev',
	},
	'legs20degrees': {
		cs: 'Horizontal foot adjustment',
    en: 'Horizontal foot adjustment',
    track: 'legs20degrees',
		opposite: 'legs20degrees_rev'
	},
	'legs20degrees_rev': {
		cs: 'Horizontal foot adjustment',
    en: 'Horizontal foot adjustment',
    track: 'legs20degrees_rev',
		opposite: 'legs20degrees'
	},
	'colposcope': {
		cs: 'Colposcope',
    en: 'Colposcope',
    track: 'colposcope',
		opposite: 'colposcope_rev'
	},
	'colposcope_rev': {
		cs: 'Colposcope',
    en: 'Colposcope',
    track: 'colposcope_rev',
		opposite: 'colposcope'
	},
	'trendelenburg': {
		cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'trendelenburg',
		opposite: 'trendelenburg_rev',
    preset: true,
    transitions: {
      'entering_position': 'tre_ent',
      'examination_position': 'tre_exa',
      'ultrasonic': 'tre_ult',
    }
	},
	'trendelenburg_rev': {
		cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'trendelenburg_rev',
		opposite: 'trendelenburg'
	},

	'backrest5': {
		cs: 'Position in laying',
    en: 'Position in laying',
    track: 'backrest5'
	},
	'backrest35': {
		cs: 'Position in laying',
    en: 'Position in laying',
    track: 'backrest35'
	},
	'backrest50': {
		cs: 'Position in laying',
    en: 'Position in laying',
    track: 'backrest50'
	},

	// prechody
	'ent_exa': {
    track: 'ent_exa'
	},
	'ent_tre': {
    track: 'ent_tre'
	},
	'ent_ult': {
    track: 'ent_ult'
	},

	'exa_ent': {
    track: 'exa_ent'
	},
	'exa_tre': {
    track: 'exa_tre'
	},
	'exa_ult': {
    track: 'exa_ult'
	},

	'ult_ent': {
    track: 'ult_ent'
	},
	'ult_tre': {
    track: 'ult_tre'
	},
	'ult_exa': {
    track: 'ult_exa'
	},

	'tre_ent': {
    track: 'tre_ent'
	},
	'tre_ult': {
    track: 'tre_ult'
	},
	'tre_exa': {
    track: 'tre_exa'
	}
}